import React from 'react';

import { Button } from 'components/bootstrap';
import { IfPermitted } from 'components/common';
import { createGRN } from 'logic/permissions/GRN';
import type { Collection, Entity } from 'collections/types';
import useCollectionEntityMutation from 'collections/hooks/useCollectionEntityMutation';

type Props = {
  collectionId: Collection['id'];
  id: Entity['id'];
  type: Entity['type'];
};

const EntityActions = ({ id, type, collectionId }: Props) => {
  const { addEntities } = useCollectionEntityMutation(collectionId);

  const onAdd = () => {
    addEntities({ addedEntities: [createGRN(type, id)] });
  };

  return (
    <IfPermitted permissions={`collection_entities:edit:${collectionId}`}>
      <Button bsSize="xs" bsStyle="primary" onClick={onAdd}>
        Add
      </Button>
    </IfPermitted>
  );
};

export default EntityActions;
